// extracted by mini-css-extract-plugin
export default {"root":"loader_root__lqxRQ","container":"loader_container__EbFEM","ldsDualRing":"loader_ldsDualRing__kue+h"};